import find from 'lodash/find'
import some from 'lodash/some'
import get from 'lodash/get'

import gtmHelpers from '../gtmHelpers'

import {gtmEvent} from './helpers'

import {TRANSACTION_TYPE_BUY, TRANSACTION_TYPE_RENT} from '../const'

const getPurchasedProducts = (selfEventLooks) => {
  const productsArray = []
  const products = selfEventLooks.map((look) => {
    look.userOrderItems.map((item) => productsArray.push(item.product))
    return productsArray
  })
  return products
}

export const orderConfirmationPageLoaded = (payload) => {
  const actionField = {
    affiliation: 'The Black Tux',
    eventId: payload.event.id,
    id: payload.id,
    promoCode: payload.totals.promoCode,
    revenue: payload.totals.total,
    shipping: payload.totals.shipping,
    tax: payload.totals.tax,
    total: payload.totals.total,
    partySize: payload.event.partySize,
  }

  const isEventCreator = payload.event.ownerId === payload.user.id
  const isSubtotalGreaterThanZero = payload.totals.subtotalForGa > 0
  const nonHtoLook = find(payload.selfEventLooks, (look) => !look.isHto)
  const orderHasHomeTryOn = payload.selfEventLooks.some((look) => look.isHto)
  const orderHasBuyNew = some(
    get(nonHtoLook, 'userOrderItems'),
    ({product}) => product.transactionType === TRANSACTION_TYPE_BUY,
  )
  const orderHasRental = some(
    get(nonHtoLook, 'userOrderItems'),
    ({product}) => product.transactionType === TRANSACTION_TYPE_RENT,
  )

  if (isEventCreator && isSubtotalGreaterThanZero) {
    actionField.eventSubtotal = payload.totals.subtotalForGa
  }

  // tags must be fired in the following order so that the creator events subtotal is available
  // to be sent through with the creator purchase event: onPurchase, onCreatorPurchase, onHTOPurchase

  gtmHelpers.onPurchase(actionField, getPurchasedProducts(payload.selfEventLooks))

  if (isEventCreator && isSubtotalGreaterThanZero) {
    gtmHelpers.onCreatorPurchase(payload.totals.subtotalForGa)

    if (orderHasBuyNew) {
      gtmEvent('buyNewCreatorPurchase')
    }
    if (orderHasRental) {
      gtmEvent('rentalCreatorPurchase')
    }
    if (orderHasHomeTryOn) {
      gtmEvent('purchaseIncludesHTO')
    }
  }
}
